// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiTableCell-body{
    padding : 4px 15px !important;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/KeyAgenda/tableStyles.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;EAC/B","sourcesContent":[".MuiTableCell-body{\n    padding : 4px 15px !important;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
